import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';
import moment from 'moment';
import { dateFormattedWithUserLocale } from 'javascripts/util/dateFns';
import { type CardLayoutModelConstructorType } from '../../types';

export class ReleaseDate extends Field {
  static get disableFieldForModelNames() {
    return ['ReleasePhase'];
  }

  static attributesForModel(modelClass) {
    if (modelClass.typename === 'Release') {
      return ['releaseDate'];
    }

    return [];
  }

  static subqueriesForModel(
    modelClass: CardLayoutModelConstructorType
  ): Record<string, any> {
    if (modelClass.typename !== 'Release') {
      return { release: ['releaseDate'] };
    }

    return {};
  }

  get title() {
    return `${terminology('Release')} date`;
  }

  exampleContents(): FieldContentsData {
    return { text: dateFormattedWithUserLocale(moment().add(4, 'months')) };
  }

  contentsForRecord(record): FieldContentsData {
    let releaseDate;

    if (record.typename === 'Release') {
      releaseDate = record.releaseDate;
    } else {
      releaseDate = record.release?.releaseDate;
    }

    if (releaseDate) {
      return {
        text: dateFormattedWithUserLocale(releaseDate),
      };
    }

    return {};
  }
}
